import moment from 'moment';

/* */
const cbLogo = require('../../../assets/images/payment/cb-icon.png');
const mcdLogo = require('../../../assets/images/payment/mcd-icon.png');
const visaLogo = require('../../../assets/images/payment/visa-icon.png');

/* */
export const anonymizeNumber = (str) => {
  if (str.length > 0) {
    return str.replace(/(\d+)(\d{4})/g, (match, start, end) => `${'*'.repeat(start.length)}${end}`);
  }
  return str;
};

export const getDueDateMY = (dueDate) => ({
  dueDateM: `${dueDate}`.substr(0, 2),
  dueDateY: `${dueDate}`.substr(2, 2),
});

/* */
export const getStatus = (dueDate, delay = 2) => {
  const expiredAt = moment(dueDate, 'MMYY');
  const deadline = moment().date(1).add(delay, 'months');

  const isExpired = expiredAt.diff(moment(), 'months', true) <= -1;
  const isSoonExpired = expiredAt.diff(deadline, 'months', true) <= 0;

  return {
    isExpired,
    isSoonExpired: !isExpired && isSoonExpired,
  };
};

/* */
export const getBrandImage = (name) => {
  let img;
  switch (name) {
    case 'CB':
      img = cbLogo;
      break;
    case 'VISA':
      img = visaLogo;
      break;
    case 'MASTERCARD':
      img = mcdLogo;
      break;
    default:
      img = null;
  }

  if (!img) return null;

  return img;
};
